module.exports = __webpack_public_path__ + "static/media/csm-no-option-selected.95fcf9f2.svg";